const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotice(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.057 3.057)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 709",
    width: 3,
    height: 14.306,
    rx: 1.5,
    transform: "translate(14.943 -.057)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 710",
    d: "M3 0h2v7.153H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z",
    transform: "translate(-.057 4.031)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 667",
    d: "M-237.968 823.678c-4.23-1.741-10.338-1.761-10.338-1.761",
    transform: "translate(252.941 -811.016)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 668",
    d: "M-237.968 809.319c-4.23 1.74-10.338 1.761-10.338 1.761",
    transform: "translate(252.941 -807.222)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 669",
    d: "m-245 822.1 1.148 5.823a.84.84 0 0 1-.632.991 2.238 2.238 0 0 1-2.636-1.8l-1.023-5.191",
    transform: "translate(252.777 -811.018)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 670",
    d: "M-240.489 822.764a2.613 2.613 0 0 1-2.584 2.641",
    transform: "translate(252.015 -810.983)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon-notice.17d967de26b24d8613284df53e404d99.svg";
export { ForwardRef as ReactComponent };